import { Component } from '@angular/core';
import { ThemeService } from '../../../core/services/theme.service';
import Icons from 'src/app/core/enums/icons.enum';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'fss-portal-theme-picker',
    templateUrl: (environment.production ? '../empty.html' : './theme-picker.component.html'),
    styleUrls: [(environment.production ? '../empty.html' : './theme-picker.component.scss')],
    standalone: false
})
export class ThemePickerComponent {
  public themes: string[] = Object.keys(this.themeService.themes);
  public icons = Icons;

  constructor( private themeService: ThemeService) {
    if (environment.production) return; 'PORTAL_TEST_CODE'; // eslint-disable-line
  }

  public themeChange(theme: string) {
    if (environment.production) return; 'PORTAL_TEST_CODE'; // eslint-disable-line
    this.themeService.setTheme(theme);
  }
}
